(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[id^="ProductSection-"]').forEach((sectionEl) => {
    const sectionId = sectionEl.id.replace('ProductSection-', '');
    const jsonEl = document.getElementById('ProductJson-' + sectionId);
    if (!jsonEl) return;
    const variants = JSON.parse(jsonEl.textContent);
    const selects = sectionEl.querySelectorAll('.product__option-select');
    const idInput = sectionEl.querySelector('#ProductVariantId');
    const priceEl = sectionEl.querySelector('#ProductPrice');
    const submitEl = sectionEl.querySelector('#ProductSubmit');
    const mainImage = sectionEl.querySelector('#ProductMainImage');

    const formatMoney = (cents) => {
      return '$' + (cents / 100).toFixed(2);
    };

    const onVariantChange = () => {
      const selected = Array.from(selects).map((s) => s.value);
      const match = variants.find((v) => selected.every((val, i) => v.options[i] === val));
      if (!match) {
        submitEl.disabled = true;
        submitEl.textContent = submitEl.dataset.unavailableText || 'Unavailable';
        return;
      }
      idInput.value = match.id;
      priceEl.innerHTML = match.compare_at_price > match.price
        ? '<s>' + formatMoney(match.compare_at_price) + '</s> ' + formatMoney(match.price)
        : formatMoney(match.price);
      submitEl.disabled = !match.available;
      submitEl.textContent = match.available
        ? (submitEl.dataset.addText || 'Add to cart')
        : (submitEl.dataset.soldOutText || 'Sold out');
      if (match.featured_image && mainImage) {
        mainImage.src = match.featured_image.src;
        mainImage.removeAttribute('srcset');
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    };

    selects.forEach((s) => s.addEventListener('change', onVariantChange));

    sectionEl.querySelectorAll('.product__thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (mainImage) {
          mainImage.src = thumb.dataset.full;
          mainImage.removeAttribute('srcset');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
